import { useTheme } from "@mui/material"
import React from "react"
import styled, { keyframes } from "styled-components"

const fadeInOutAnim = keyframes`
  0% { opacity: 0; }
  30% { opacity: 0; }
  50% { opacity: 1; }
  70% { opacity: 1; }
  100% { opacity: 0; }
`

const EightyTwentyTenWrap = styled.div<{ bg: string }>`
  display: inline-flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  margin: auto;
  padding: 2rem;
  background: ${p => p.bg};
`

const Part = styled.div<{ borderColor: string }>`
  padding: 1rem;
  animation: ${fadeInOutAnim} 1.4s infinite;
  opacity: 0;
  margin: 2px;
  border-bottom: ${p => `1px solid ${p.borderColor}`};
  > span {
    position: relative;
  }
`

const Eighty = styled(Part)`
  animation-delay: 0;
  border-bottom-width: 8px;

  > span {
    bottom: 0;
  }
`
const Twenty = styled(Part)`
  animation-delay: 300ms;
  border-bottom-width: 2px;
  > span {
    bottom: 0;
  }
`
const Ten = styled(Part)`
  animation-delay: 600ms;
  border-bottom-width: 1px;
  > span {
    bottom: 0;
  }
`

type ILoadingIndicator = {
  /**
   * Additional styles to be added to the wrapper for layout purposes
   * @default {}
   */
  styles: React.CSSProperties
  /**
   * Type
   * @default "80:20:10"
   */
  variant?: string
}

const EightyTwentyTen = ({ styles = {} }): React.ReactElement => {
  const theme = useTheme()
  return (
    <EightyTwentyTenWrap
      bg={theme.palette.background.paper}
      style={{ ...styles }}
    >
      <Eighty borderColor={theme.palette.primary.light}>
        <span>80</span>
      </Eighty>
      <Twenty borderColor={theme.palette.primary.light}>
        <span>20</span>
      </Twenty>
      <Ten borderColor={theme.palette.primary.light}>
        <span>10</span>
      </Ten>
    </EightyTwentyTenWrap>
  )
}

export const LoadingIndicator = ({
  styles = {},
  variant = "80:20:10"
}: ILoadingIndicator): React.ReactElement => {
  return <EightyTwentyTen styles={styles} />
}

export default LoadingIndicator
